<jhi-bary-card class="h-100" title="{{ 'USER_CARD.TITLE' | translate }}">
  <div body>
    <div *ngIf="isEditMode; else weblinksNotUpdate">
      <div class="row" *ngIf="description">
        <div class="col-12">
          <p class="text-lead">{{ description }}</p>
        </div>
      </div>
      <form>
        <div class="row">
          <div class="col-12 flex-shrink-1" *ngIf="isBaryUser">
            <jhi-bary-input-select data-id-cypress="civility" [control]="getControl('civility')" [options]="CIVILITIES_OPTIONS"></jhi-bary-input-select>
          </div>
          <div class="col-auto flex-grow-1">
            <jhi-bary-input-text data-id-cypress="first-name" [id]="'firstName'" [label]="'LABEL.FIRSTNAME' | translate" [control]="getControl('firstName')"></jhi-bary-input-text>
          </div>
          <div class="col-auto flex-grow-1">
            <jhi-bary-input-text data-id-cypress="last-name" [id]="'lastName'" [label]="'LABEL.LASTNAME' | translate" [control]="getControl('lastName')"></jhi-bary-input-text>
          </div>
        </div>
        <div class="row" *ngIf="!isIndividual()">
          <div class="col-12">
            <jhi-bary-input-select
              data-id-cypress="position"
              [id]="'position'"
              [label]="'LABEL.FUNCTION' | translate"
              [control]="getControl('position')"
              [options]="getPosition()"
            ></jhi-bary-input-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <jhi-bary-date-picker
              data-id-cypress="date"
              [id]="'dateBirth'"
              [label]="'register.form.userInformation.dateBirth.label' | translate"
              [placeholder]="'register.form.userInformation.dateBirth.placeholder' | translate"
              [control]="getControl('dateBirth')"
              [isDisableWeekends]="false"
              [options]="DEFAULT_OPTIONS"
              [disabled]="true"
              [touched]="touched"
            ></jhi-bary-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <jhi-bary-input-phone [label]="'register.form.userInformation.phone' | translate" [control]="getControl('phone')" *ngIf="isBaryUser"></jhi-bary-input-phone>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <jhi-bary-input-email
              data-id-cypress="email"
              [id]="'email'"
              [label]="'register.form.userInformation.email' | translate"
              [control]="getControl('email')"
            ></jhi-bary-input-email>
          </div>
        </div>
        <div class="row" *ngIf="register">
          <div class="col-12">
            <jhi-bary-input-password
              data-id-cypress="password"
              id="password"
              [label]="'register.form.userInformation.password' | translate"
              [control]="getControl('password')"
            ></jhi-bary-input-password>
          </div>
          <div class="col-12">
            <jhi-bary-input-password
              data-id-cypress="confirm-password"
              [id]="'confirmPassword'"
              [label]="'register.form.userInformation.confirmPassword' | translate"
              [control]="getControl('confirmPassword')"
              [isConfirm]="true"
            ></jhi-bary-input-password>
          </div>
        </div>
      </form>
    </div>
    <ng-template #weblinksNotUpdate>
      <ul class="striped list-unstyled" *ngIf="user">
        <li class="mb-3 text-center">
          <span class="font-weight-bold" data-id-cypress="user-fullname">{{ getCivility() }}&nbsp;{{ user.lastName.toUpperCase() }}&nbsp;{{ user.firstName }}</span>
        </li>
        <li class="mb-1" *ngIf="!isIndividual()">
          <span class="font-weight-bold">{{ 'LABEL.FUNCTION' | translate }}&nbsp;:</span>
          <span data-id-cypress="user-function" *ngIf="isPosition(user.position)">{{ user.position.labelKey! | translate }}</span>
        </li>
        <li class="mb-1">
          <span class="font-weight-bold">{{ 'LABEL.BIRTHDAY' | translate }}&nbsp;:</span>
          <span data-id-cypress="user-birthday">{{ user.dateBirth | date: 'dd/MM/yyyy' }}</span>
        </li>
        <li class="mb-1">
          <span class="font-weight-bold">{{ 'LABEL.PHONE' | translate }}&nbsp;:</span>
          <span data-id-cypress="user-phone" *ngIf="user.phone">{{ user.phone | phoneFormat }}</span>
        </li>
        <li class="mb-1">
          <span class="font-weight-bold">{{ 'LABEL.EMAIL' | translate }}&nbsp;:</span>
          <span data-id-cypress="user-phone">{{ user.email }}</span>
        </li>
      </ul>
    </ng-template>
    <ng-container *ngIf="!register">
      <p class="alert alert-warning" jhiTranslate="register.form.userInformation.changingEmailWarning">Attention</p>
      <div class="row" *ngIf="!register">
        <div class="col-12">
          <jhi-bary-button [block]="true" [label]="'LABEL.CHANGE_PASSWORD' | translate" color="grey" (click)="openModalChangePassword()"></jhi-bary-button>
        </div>
      </div>
    </ng-container>
  </div>
  <div footer *ngIf="switchButton" class="d-flex justify-content-end p-3">
    <jhi-bary-button
      data-id-cypress="btn-update-user-info"
      *ngIf="!isEditMode"
      (click)="isEditMode = true"
      class="btn bary-btn mx-6"
      icon="pen"
      [label]="'BTN.MODIFY' | translate"
    ></jhi-bary-button>
    <jhi-bary-button *ngIf="isEditMode" icon="times" class="btn bary-btn mr-3" color="danger" [label]="'BTN.CANCEL' | translate" (click)="isEditMode = false; action.emit(false)">
    </jhi-bary-button>
    <jhi-bary-button
      *ngIf="isEditMode"
      (click)="isEditMode = false; action.emit(true)"
      data-id-cypress="button-save-user-info"
      [disabled]="userForm.invalid"
      [label]="'BTN.SAVE' | translate"
      icon="save"
    ></jhi-bary-button>
  </div>
</jhi-bary-card>
